module.exports = __webpack_public_path__ + "img/ico_regular_user.68ec2088.svg";